var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "navbar-upload" },
    [
      _c("VIcon", { attrs: { icon: "upload", size: 18 } }),
      _vm._v(" "),
      _c("div", { staticClass: "navbar-upload-name" }, [_vm._v("投稿")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }